import {httpPost} from './http.service';
import {IChat} from '../incase-domain/elements/chatbot';

export const initChat = (chatbotId: string, runfileId: string): Promise<IChat> => {
    return httpPost(`player/chatbot`, {chatbotId, runfileId});
};

export const getAnswers = (chatId: string, message?: string): Promise<IChat> => {
    return httpPost(`player/chatbot/${chatId}/getAnswer`, {message});
};
